export default __webpack_public_path__ + "static/media/Sleve McDichael.a5e5d794.jpg";